import { render, staticRenderFns } from "./RegistrationRouteMessages.vue?vue&type=template&id=4b112772&"
import script from "./RegistrationRouteMessages.vue?vue&type=script&lang=ts&"
export * from "./RegistrationRouteMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports